import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, MessageCircle, Download } from "lucide-react";
import logo from "@/assets/logo.jpeg";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  const navLinks = [
    { label: "About", id: "about" },
    { label: "Plans", id: "plans" },
    { label: "How It Works", id: "how-it-works" },
    { label: "Security", id: "security" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-gold-dark/30 bg-background/80 backdrop-blur-xl animate-[slideDown_0.6s_ease-out_both]">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Prime Profit" className="h-10 w-auto rounded" />
          <span className="font-display text-lg font-bold gradient-gold-text">PRIME PROFIT</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden items-center gap-6 md:flex">
          {navLinks.map((link) => (
            <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-sm text-muted-foreground transition-colors hover:text-gold">{link.label}</button>
          ))}
          <a href="https://t.me/officialprimeprofit" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground transition-colors hover:text-gold flex items-center gap-1"><MessageCircle size={16} />Chat</a>
          <a href="https://t.me/primeprofit_channel" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground transition-colors hover:text-gold flex items-center gap-1"><MessageCircle size={16} />Channel</a>
          <Link to="/install" className="text-sm text-muted-foreground transition-colors hover:text-gold flex items-center gap-1"><Download size={16} />Get App</Link>
          <Link to="/login" className="rounded-md border border-gold-dark px-4 py-2 text-sm font-medium text-gold transition-all hover:bg-gold hover:text-primary-foreground">Login</Link>
          <Link to="/login" className="rounded-md gradient-gold px-4 py-2 text-sm font-semibold text-primary-foreground transition-all hover:scale-105 hover:shadow-[0_0_20px_hsl(var(--gold)/0.4)]">Sign Out</Link>
        </div>

        {/* Mobile hamburger */}
        <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-gold p-2" aria-label="Toggle menu">
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gold-dark/30 bg-background/95 backdrop-blur-xl animate-[fadeSlideUp_0.3s_ease-out_both]">
          <div className="container mx-auto flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <button key={link.id} onClick={() => scrollToSection(link.id)} className="rounded-lg px-4 py-3 text-left text-sm text-muted-foreground transition-colors hover:bg-gold/10 hover:text-gold">{link.label}</button>
            ))}
            <div className="my-2 border-t border-border" />
            <a href="https://t.me/officialprimeprofit" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)} className="rounded-lg px-4 py-3 text-sm text-muted-foreground transition-colors hover:bg-gold/10 hover:text-gold flex items-center gap-2"><MessageCircle size={16} />Telegram Chat</a>
            <a href="https://t.me/primeprofit_channel" target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)} className="rounded-lg px-4 py-3 text-sm text-muted-foreground transition-colors hover:bg-gold/10 hover:text-gold flex items-center gap-2"><MessageCircle size={16} />Telegram Channel</a>
            <Link to="/install" onClick={() => setMobileOpen(false)} className="rounded-lg px-4 py-3 text-sm text-muted-foreground transition-colors hover:bg-gold/10 hover:text-gold flex items-center gap-2"><Download size={16} />Get App</Link>
            <Link to="/login" onClick={() => setMobileOpen(false)} className="rounded-lg px-4 py-3 text-sm font-medium text-gold transition-colors hover:bg-gold/10">Login</Link>
            <Link to="/login" onClick={() => setMobileOpen(false)} className="rounded-lg gradient-gold px-4 py-3 text-center text-sm font-semibold text-primary-foreground">Sign Out</Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
